import script from "./CustomerSubscriptions.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerSubscriptions.vue?vue&type=script&setup=true&lang=js"

import "./CustomerSubscriptions.vue?vue&type=style&index=0&id=41dee356&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41dee356"]])

export default __exports__